import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import FormTitle from '@src/mobile/phtvHostSurvey2024/layout/Component/FormTitle';
import UploadVideo from './UploadVideo';
import UploadPic from './UploadPic';

const Media = ({ formData, setFormDataHandle, warningTextList, updateId, updateSuccess }) => {
    
    const changeInputHandle = (key, value) => {
        setFormDataHandle(key, value);
    };

    return (
        <div className={styles.media}>
            <FormTitle name="img" title="形象照片" warningText={warningTextList['img']} isRequired={true} />
            <div className={styles.picInfo}>面貌清晰的半身、全身各一張<br />圖片僅支持jpeg、png、gif、jpg格式</div>
            <div className={styles.picList}>
                <UploadPic name="img1" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
                <UploadPic name="img2" formData={formData} changeInputHandle={changeInputHandle} updateId={updateId} updateSuccess={updateSuccess} />
            </div>
            <FormTitle name="video_self" title="自我介紹視頻" warningText={warningTextList['video_self']} isRequired={true} />
            <div className={styles.picInfo}>請保證視頻在1分鐘以內、不使用美顏、不使用濾鏡<br />視頻僅支持mp4、mov、quicktime格式</div>
            <UploadVideo name="video_self" formData={formData} changeInputHandle={changeInputHandle} />
        </div>
    );
};

Media.propTypes = {
    formData: PropTypes.object,
    setFormDataHandle: PropTypes.func,
    warningTextList: PropTypes.object,
    updateId: PropTypes.string,
    updateSuccess: PropTypes.bool
};

export default errorBoundary(Media);
